import script from "./AutoSaveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoSaveModal.vue?vue&type=script&setup=true&lang=js"

import "./AutoSaveModal.vue?vue&type=style&index=0&id=bd9284ac&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd9284ac"]])

export default __exports__